<div class="main-wrapper" [ngClass]="{'offcanvas-open': offcanvasService.offcanvasNavigationOpen | async}">
<!-- à  -->
<!--    <app-navigation-off-canvas></app-navigation-off-canvas>

    <app-top-bar></app-top-bar>-->
    <app-header></app-header>
    <app-content></app-content>
<!--    <app-footer></app-footer>-->

</div>
